<template>
  <div>
    
    <div class="tr header" v-if="props.index === 0">
      <div class="th lrr-ref">LRR ref</div>
      <div class="th tags">Tags</div>
      <div class="th lrr-type">LRR type</div>
      <div class="th supplier-id">Supplier Id</div>
      <div class="th type">alert type</div>
      <div class="th started">alert since</div>
      <div class="th actions">&nbsp;</div>
    </div>

    <div class="tr" :class="{even: props.index % 2 === 0}">
      <div class="td lrr-ref">
        <div class="fw-bold"><a @click="lrrRefClicked(props.alert.lrrRef)" data-tippy-content="open in base station view">{{props.alert.lrrRef}}</a></div>
        <div :title="props.alert.baseStation.name">{{formatName(props.alert.baseStation.name)}}</div>
      </div>
      <div class="td tags">
        <div v-for="tag in props.alert.baseStation.tags" :key="tag" class="ow">
          <span class="badge bg-success rounded-pill" >{{tag}}</span>
        </div>
      </div>
      <div class="td lrr-type">
        <span class="text-dark small"><font-awesome-icon icon="tag"/> {{props.alert.baseStation.commercialName}}</span>
      </div>

      <div class="td supplier-id">
        <span class="text-dark small"><font-awesome-icon icon="suitcase-rolling"/> {{props.alert.baseStation.supplierId}}</span>
      </div>

      <div class="td type">
        <div v-if="props.alert.type === 'conn-status'">
          <span class="badge bg-danger"><font-awesome-icon icon="plug"/> LOST CONNECTION</span>
        </div>
        <div v-else><font-awesome-icon icon="danger"/>{{props.alert.type}}</div>
      </div>
      <div class="td started">
        <div>{{formatTs(props.alert.startTs).time}}</div>
        <div class="font-italic">{{formatTs(props.alert.startTs).ago}}</div>
      </div>

      <div class="td actions">
        <button 
          type="button" 
          class="btn btn-danger btn-sm" 
          data-tippy-content="clear alert"
          @click="clearAlert(props.alert.alertId)"
          :class="{disabled:props.disabled}"
>
          <font-awesome-icon icon="trash"/>
        </button>
      </div>
     
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { sharedState } from '@/shared';

import dayjs from '@/plugins/dayjs';
import tippy from 'tippy.js';
import { FullAlert } from '@/types';

interface Props {
  alert?: FullAlert;
  disabled?: boolean;
  index?: number;
}

const props = withDefaults(defineProps<Props>(), {
  alert: () => ({} as FullAlert),
  disabled: false,
  index: 0
});

const emit = defineEmits<{
  'clear-alert': [alertId: string];
}>();

const router = useRouter();

onMounted(() => {
  tippy('[data-tippy-content]');
});

function formatTs(ts: number | undefined): {time: string, ago: string} {
  return {
    time: ts ? dayjs(ts).format('L LT') : 'N/A',
    ago: ts ? dayjs(ts).fromNow() : 'N/A'
  };
}

function formatName(name: string): string {
  if (name.length <= 40) {
    return name;
  }
  return name.substring(0, 40 - 3) + '...';
}

function lrrRefClicked(lrrRef: string) {
  sharedState.lrrRef = lrrRef;
  router.push({ name: 'base-stations' });
  //router.push({name: 'base-stations', params: {searchTerm: lrrRef} });
}

function clearAlert(alertId: string) {
  emit('clear-alert', alertId);
}
</script>

<style scoped lang="scss">
@use "@/variables.scss" as *;

.tr {
  display: flex;
  flex-direction: row;
  text-align: left;
  justify-content: space-between;
  margin-bottom: 2px;
}

.tr.even {
  background-color: $bgColourLight;
}

.tr.header {
  background-color: white;
  border-bottom: 1px solid $bgColour;
}

.th {
  color: $bgColour;
  font-weight: bold;
}

.th, .td {
  padding: 4px;
}

.td.lrr-ref, .th.lrr-ref {
  width: 30%;
}

.td.tags, .th.tags {
  width: 14%;
}

.td.lrr-type, .th.lrr-type {
  width: 18%;
  overflow: hidden;
}

.td.supplier-id, .th.supplier-id {
  width: 15%;
}

.td.type, .th.type {
  width: 14%;
}

.td.started, .th.started {
  width: 16%;
}

.td.actions, .th.actions {
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  width: 5%;
}

.badge.larger {
  font-size: 85%;
}

.badge {
  padding: 0.30em 0.4em;
}

a {
  font-weight: bold;
  color: $bgColour !important;
  cursor: pointer;
}

</style>